export default __webpack_public_path__ + "static/media/paycheck.1cfd72a9.png";